import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Progress?",
  "description": "",
  "published": "2006-11-15T00:00:00.000Z",
  "redirect_from": ["/blog/progress/swizec/358"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago I was contemplating the development of Slovene as a language and found something strikingly fascinating and perhaps a bit scary. There appears to exist a certain tendency to adopt nonslovene words in common speech and to do that a lot. An interesting observation thus provides itself that in the time of our grandmothers a lot of the words in common speech were stolen from German in one form or another. Now there is a tendency to consider use of such words as quaint, old and overly uneducated. Oh no, us younger people do the same with English, except we call it slang and think of ourselves as having invented something completely new and awesome. We are teh bomb, as you could say, where our forefathers hurt the language with German we do it with English.`}</p>
    <p>{`So what the hell, are we killing ourselves? Or are the powers of great strength mangling our wee minds into submission?`}</p>
    <p>{`Another thing about progress that's really amusing is how I've written 5500ish words of this year's NaNo in the first two days, and the 13 days after that received what, only just above 5000 words? Oh yes, there most hopefully is not a pattern in there somewhere. A good thing though is that I got my first `}<a parentName="p" {...{
        "href": "http://www.locutio.si/index.php?no=32&clanek=721"
      }}>{`publish`}</a>{` in a magazine, an electronic one and just an excerpt, but hey, it's the first one.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      